module.exports = __webpack_public_path__ + "static/media/thunderstorm.8e656306.svg";